import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Encoders from './Encoders';
import DCPNodes from './DCPNodes';
import DeliveryNodes from './DeliveryNodes';

const VARIANT_ORDER = ['screener', 'dcp', 'utility', 'delivery'];
const VARIANTS = {
  screener: { title: 'Watermark Encoders', subtitle: 'Watermark encoder nodes', tabLabel: 'Watermark', component: Encoders, props: {} },
  dcp:      { title: 'DCP Encoders',       subtitle: 'Digital Cinema Package encoder nodes', tabLabel: 'DCP', component: DCPNodes, props: { role: 'encode' } },
  utility:  { title: 'Utility Nodes',      subtitle: 'KDM generation + QC nodes (no JPEG2000 builds)', tabLabel: 'Utility', component: DCPNodes, props: { role: 'utility' } },
  delivery: { title: 'Delivery Nodes',     subtitle: 'MinIO object storage for file delivery', tabLabel: 'Delivery', component: DeliveryNodes, props: {} },
};

function Nodes() {
  const navigate = useNavigate();
  const { variant = 'screener' } = useParams();
  const config = VARIANTS[variant] || VARIANTS.screener;
  const Component = config.component;
  const activeVariant = VARIANTS[variant] ? variant : 'screener';

  const handleTab = (_, next) => {
    navigate(next === 'screener' ? '/operator/nodes' : `/operator/nodes/${next}`);
  };

  return (
    <Box>
      <PageHeader title={config.title} subtitle={config.subtitle} />
      <Tabs value={activeVariant} onChange={handleTab} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        {VARIANT_ORDER.map((v) => (
          <Tab key={v} value={v} label={VARIANTS[v].tabLabel} />
        ))}
      </Tabs>
      <Component {...config.props} />
    </Box>
  );
}

export default Nodes;
